import day_off from "../views/day_off/index.vue";
import day_off_create from "../views/day_off/create.vue";
import day_off_edit from "../views/day_off/edit.vue";
import day_off_detail from "../views/day_off/detail.vue";
import day_off_import from "../views/day_off/import.vue";

const routes = [
  {
    path: "/day_off",
    name: "day_off",
    component: day_off,
    meta: { authOnly: true }
  },
  {
    path: "/day_off/create",
    name: "day_off_create",
    component: day_off_create,
    meta: { authOnly: true }
  },
  {
    path: "/day_off/edit/:uuid",
    name: "day_off_edit",
    component: day_off_edit,
    meta: { authOnly: true }
  },
  {
    path: "/day_off/detail/:uuid",
    name: "day_off_detail",
    component: day_off_detail,
    meta: { authOnly: true }
  },
  {
    path: "/day_off/import",
    name: "day_off_import",
    component: day_off_import,
    meta: { authOnly: true }
  }
];

export default routes;
